<template>
    <div>
        <CRow>
            <CCol>
                <Trends />
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="8">
                <CRow>
                    <CCol><h5>My savings portfolio</h5></CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <AchievedSavings />
                    </CCol>
                    <CCol sm="6">
                        <Projects />
                    </CCol>
                </CRow>
            </CCol>
            <CCol>
                <SpendmdNews />
            </CCol>
        </CRow>
    </div>
</template>

<script>
import Trends from "./Components/Trends";
import AchievedSavings from "./Components/AchievedSavings";
import Projects from "./Components/Projects";
import SpendmdNews from "./Components/SpendmdNews";

export default {
    data() {
        return {};
    },
    components: {
        Trends,
        AchievedSavings,
        Projects,
        SpendmdNews,
    },
};
</script>